import ApiService from '@/common/api.service'
import {
  CREATE_REQUEST_URL,
} from '@/common/config'
import {
  CREATE_REQUEST,
} from './actions.type'

const state = {
  userRequests: []
}

const actions = {
  [CREATE_REQUEST] (context, data) {
    return new Promise((resolve, reject) => {
      ApiService.post(CREATE_REQUEST_URL, data).then(() => {
        resolve()
      }).catch(() => {
        reject()
      })
    })
  },
}

const mutations = {
}

export default {
  state,
  actions,
  mutations
}
